<div class="clients-page">
  <h2 class="clients-page__header h1">Clients Directory</h2>
  <div class="clients-page__controls">
    <form [formGroup]="form" class="clients-page__filters">
      <mat-form-field appearance="fill" class="filters-form-field">
        <mat-label>Search clients</mat-label>
        <mat-icon matPrefix class="me-2">search</mat-icon>
        <input matInput [formControlName]="'name'" placeholder="Type to filter clients...">
      </mat-form-field>
      @if (isManager) {
      <button (click)="openCreateClientDialog('0ms','0ms')" mat-flat-button>Create client</button>
      }
    </form>
  </div>

  @if (isManager) {
  <button mat-flat-button (click)="openItemAnnihilatorDialog('0ms', '0ms')">Delete clients</button>
  }

  <div class="clients-page__grid">
    @for (group of groupedClients; track group.letter) {
    <div class="clients-page__letter-group">
      <div class="clients-page__letter-header">{{group.letter}}</div>
      <div class="clients-page__clients-group">
        @for (client of group.clients; track client.id) {
        <div class="clients-page__client-card mat-elevation-z2">
          <div class="clients-page__client-name">{{client.name}}</div>
          <div class="clients-page__client-actions">
            @if (isManager) {
            <button mat-flat-button (click)="openUpdateClientDialog(client.id,'0ms','0ms')">Update</button>
            <button mat-flat-button (click)="deleteClient(client)">Delete</button>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
